// src/utils/assets/holderUtils.js

import {
    HOLDER_TYPES
} from "../../constants/holderTypes";

import {
    getHolderDisplayName,
    resolveHolder,
    isValidHolderType
} from "../holderResolver";

import {
    createHolderSnapshot
} from "../holderSnapshotFactory";

/**
 * Normalize holder type safely
 * Legacy compatibility support
 */
export const normalizeHolderType = (
    value
) => {

    const normalized = String(
        value || ""
    )
        .trim()
        .toUpperCase();

    // ==========================================
    // LEGACY FALLBACKS
    // ==========================================

    if (
        normalized === "PERSON" ||
        normalized === "TECH"
    ) {
        return HOLDER_TYPES.TECHNICIAN;
    }

    if (
        normalized === "EMP"
    ) {
        return HOLDER_TYPES.EMPLOYEE;
    }

    return normalized;
};

/**
 * Check if holder type is staff-like
 */
export const isStaffHolderType = (
    holderType
) => {

    const normalized =
        normalizeHolderType(
            holderType
        );

    return [
        HOLDER_TYPES.TECHNICIAN,
        HOLDER_TYPES.STAFF,
        HOLDER_TYPES.EMPLOYEE
    ].includes(normalized);

};

/**
 * Get clean holder label
 */
export const getHolderLabel = ({
    holderType,
    holderId,
    collection = []
}) => {

    return getHolderDisplayName({
        holderType:
            normalizeHolderType(
                holderType
            ),

        holderId,
        collection
    });

};

/**
 * Resolve holder safely
 */
export const getResolvedHolder = ({
    holderType,
    holderId,
    collection = []
}) => {

    return resolveHolder({
        holderType:
            normalizeHolderType(
                holderType
            ),

        holderId,
        collection
    });

};

/**
 * Create immutable holder snapshot
 */
export const buildHolderSnapshot = ({
    holderType,
    holderId,
    collection = []
}) => {

    return createHolderSnapshot({
        holderType:
            normalizeHolderType(
                holderType
            ),

        holderId,
        collection
    });

};

/**
 * Validate holder assignment
 */
export const validateHolderAssignment = ({
    holderType,
    holderId
}) => {

    if (!holderType) {
        return {
            valid: false,
            message:
                "Holder type is required"
        };
    }

    if (!holderId) {
        return {
            valid: false,
            message:
                "Holder ID is required"
        };
    }

    const normalizedType =
        normalizeHolderType(
            holderType
        );

    if (
        !isValidHolderType(
            normalizedType
        )
    ) {
        return {
            valid: false,
            message:
                "Invalid holder type"
        };
    }

    return {
        valid: true,
        message: ""
    };

};

/**
 * Safe holder compare
 */
export const isSameHolder = ({
    sourceType,
    sourceId,
    targetType,
    targetId
}) => {

    return (

        normalizeHolderType(
            sourceType
        ) ===

        normalizeHolderType(
            targetType
        ) &&

        String(
            sourceId || ""
        ).trim() ===

        String(
            targetId || ""
        ).trim()

    );

};